export const typeOptionsNames = {
    TYPE_P : "typeP",
    TYPE_L : "typeL",
    TYPE_S : "typeS",
}

export const dimensionsNames = {
    HEIGHT : "height",
    LENGTH : "length",
    WIDTH : "width",
    TILT_ANGLE: "tiltAngle"
}

export const colorsNames = {
    GRAY : "gray",
    OTHER : "other"
}

export const boardNames = {
    BIG: "big",
    SMALL: "small",
    NONE: "none"
}

export const deliveryNames = {
    PERSONAL_PICKUP: "personalPickup",
    COURIER: "courier",
    PARCEL_LOCKER: "parcelLocker",
    POST_OFFICE: "postOffice"
}

export const personalDataNames = {
    NAME: "name",
    SURNAME: "surname",
    EMAIL: "email",
    PHONE_NUMBER: "phoneNumber",
    STREET: "street",
    HOUSE_NUMBER: "houseNumber",
    ZIP: "zip",
    CITY: "city",
    COUNTRY: "country",
    PARCEL_LOCKER_NUMBER: "parcelLockerNumber"
}

